// import { firestore } from './firebase'; // Firebase setup
// import { collection, query, where, getDocs } from 'firebase/firestore';

// export const validateUserBooking = async (eventId, userEmail) => {
//   try {
//     // Reference to the 'bookings' collection
//     const bookingsRef = collection(firestore, 'bookings');
    
//     // Create a query to find bookings matching the eventId and userId
//     const bookingQuery = query(
//       bookingsRef,
//       where('eventId', '==', eventId),
//       where('userEmail', '==', userEmail)
//     );
    
//     // Fetch the results of the query
//     const querySnapshot = await getDocs(bookingQuery);
    
//     // Check if any documents were found in the query
//     return !querySnapshot.empty; // Returns true if the user has a booking
//   } catch (error) {
//     console.error("Error validating user booking:", error);
//     return false;
//   }
// };
// import { firestore } from './firebase'; // Firebase setup
// import { collection, query, where, getDocs } from 'firebase/firestore';

// export const validateUserBooking = async (eventId, userEmail) => {
//   try {
//     // Reference to the 'userBookings' collection
//     const userBookingsRef = collection(firestore, 'userBookings');
    
//     // Create a query to find bookings matching the eventId and userEmail
//     const bookingQuery = query(
//       userBookingsRef,
//       where('eventId', '==', eventId),
//       where('userEmail', '==', userEmail)
//     );
    
//     // Fetch the results of the query
//     const querySnapshot = await getDocs(bookingQuery);
    
//     // Check if any documents were found in the query
//     return !querySnapshot.empty; // Returns true if the user has a booking
//   } catch (error) {
//     console.error("Error validating user booking:", error);
//     return false;
//   }
// };




// import { firestore } from './firebase'; // Firebase setup
// import { collection, query, where, getDocs } from 'firebase/firestore';

// export const validateUserBooking = async (eventId, userEmail) => {
//   try {
//     if (!eventId || !userEmail) {
//       console.error("Missing eventId or userEmail.");
//       return false;
//     }

//     // Reference to the 'userBookings' collection
//     const userBookingsRef = collection(firestore, 'userBookings');
    
//     // Create a query to find bookings matching the eventId and userEmail
//     const bookingQuery = query(
//       userBookingsRef,
//       where('eventId', '==', eventId),
//       where('userEmail', '==', userEmail)
//     );
    
//     // Fetch the results of the query
//     const querySnapshot = await getDocs(bookingQuery);
    
//     if (!querySnapshot.empty) {
//       console.log("User booking found for event:", eventId);
//       return true; // User has booked the event
//     } else {
//       console.log("No booking found for this user and event.");
//       return false;
//     }
//   } catch (error) {
//     console.error("Error validating user booking:", error);
//     return false;
//   }
// };



import { firestore } from './firebase'; // Firebase setup
import { collection, query, where, getDocs } from 'firebase/firestore';

export const validateUserBooking = async (eventId, userEmail) => {
  try {
    if (!eventId || !userEmail) {
      console.error("Missing eventId or userEmail.");
      return false;
    }

    // Reference to the 'userBookings' collection
    const userBookingsRef = collection(firestore, 'userBookings');
    
    // Create a query to find bookings matching eventId, userEmail, and userConfirmed
    const bookingQuery = query(
      userBookingsRef,
      where('eventId', '==', eventId),
      where('userEmail', '==', userEmail),
      where('userConfirmed', '==', true) // Only consider confirmed bookings
    );
    
    // Fetch the results of the query
    const querySnapshot = await getDocs(bookingQuery);
    
    if (!querySnapshot.empty) {
      console.log("Confirmed booking found for event:", eventId);
      return true; // User has a confirmed booking
    } else {
      console.log("No confirmed booking found for this user and event.");
      return false;
    }
  } catch (error) {
    console.error("Error validating user booking:", error);
    return false;
  }
};
